module.exports = __webpack_public_path__ + "img/banner_phone_jl.599daa20.png";